import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Design Graph"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "design-graph"
    }}>{`Design Graph`}</h1>
    <p>{`The core organizing principle for styles in Theme UI is based
on a conceptual model called the `}<em parentName="p">{`Design Graph`}</em>{`.`}</p>
    <p>{`The Design Graph is composed of the following nodes:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Scales`}</strong>{` are limited collections of raw values that map to specific style properties.
For example, values for `}<inlineCode parentName="li">{`font-size`}</inlineCode>{` are stored in the `}<inlineCode parentName="li">{`fontSizes`}</inlineCode>{` scale.`}</li>
      <li parentName="ul"><strong parentName="li">{`Components`}</strong>{` are elements that have styles constrained by `}<em parentName="li">{`scales`}</em>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Variants`}</strong>{` are partial styles that map to specific components.
For example, a button might have `}<em parentName="li">{`primary`}</em>{` and `}<em parentName="li">{`secondary`}</em>{` variants, or `}<em parentName="li">{`large`}</em>{` and `}<em parentName="li">{`small`}</em>{` variants.`}</li>
      <li parentName="ul"><strong parentName="li">{`Themes`}</strong>{` are collections of `}<em parentName="li">{`scales`}</em>{` (and possibly `}<em parentName="li">{`variants`}</em>{`) that encapsulate a particular visual design language.
Ideally, themes follow a common interface (or schema) and can be swapped out in different implementations.`}</li>
    </ul>
    <p>{`The Design Graph provides a way to think and talk about the styles in Theme UI,
and the `}<a parentName="p" {...{
        "href": "/theme-spec"
      }}>{`Theme Specification`}</a>{` is the primary interface for theme objects.`}</p>
    <p>{`To read more about the Design Graph, see the original `}<a parentName="p" {...{
        "href": "https://jxnblk.com/blog/design-graph"
      }}>{`blog post`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      